import { get } from "../index";

// Numbered model versions of a project, newest first, each with which
// Revit documents it changed since the one before (routes/modelVersions.js).
export const getModelVersions = (projectId, limit = 50) =>
  get(`/model-versions/project/${projectId}?limit=${limit}`);
